export const DOCUMENT_UID_KEY = 'document_UID';
